export default {
  ordinalNumber (val: number | string) {
    const s = ['th', 'st', 'nd', 'rd']
    const v = parseInt(val as string, 10) % 100
    return val + (s[(v - 20) % 10] || s[v] || s[0])
  }
}
